import React from "react";
import { CheckIcon } from "../Icons";
import { IconTile, Section, SectionHeading, SectionLabel } from "../ui";
import { WAYS_TO_WORK } from "./content";

export default function WaysToWork() {
  return (
    <Section>
      <div className="tw-mx-auto tw-max-w-3xl tw-text-center">
        <SectionLabel>Three ways to work with us</SectionLabel>
        <SectionHeading>Choose based on who will run the programme.</SectionHeading>
        <p className="tw-mt-5 tw-mb-0 tw-text-lg tw-leading-8 tw-text-[#5b7188]">
          The platform stays at the centre. FutureLab&rsquo;s delivery support can be added around it.
        </p>
      </div>

      <div className="tw-mt-12 tw-grid tw-grid-cols-3 tw-gap-5 sm:tw-grid-cols-1">
        {WAYS_TO_WORK.map((way) => (
          <article
            key={way.key}
            className={`tw-relative tw-rounded-[26px] tw-border tw-p-7 ${
              way.badge
                ? "tw-border-[#087bd3] tw-bg-[#eef7fd] tw-shadow-[0_18px_50px_rgba(27,93,139,.12)]"
                : "tw-border-[#d4e2ee] tw-bg-white"
            }`}
          >
            {way.badge ? (
              <span className="tw-absolute tw-right-5 tw-top-5 tw-rounded-full tw-bg-[#087bd3] tw-px-3 tw-py-1 tw-text-[11px] tw-font-black tw-uppercase tw-tracking-wider tw-text-white">
                {way.badge}
              </span>
            ) : null}

            <IconTile icon={way.icon} variant={way.badge ? "solid" : "soft"} className="tw-mb-5" />

            <p
              className={`tw-m-0 tw-text-xs tw-font-black tw-uppercase tw-tracking-[.12em] tw-text-[#087bd3] ${
                way.badge ? "tw-pr-24" : ""
              }`}
            >
              {way.eyebrow}
            </p>
            <h3 className="tw-mt-4 tw-mb-0 tw-text-2xl tw-font-black tw-leading-8 tw-tracking-[-.03em] tw-text-[#163552]">
              {way.title}
            </h3>
            <p className="tw-mt-4 tw-mb-0 tw-min-h-20 tw-leading-7 tw-text-[#5b7188] sm:tw-min-h-0">
              {way.body}
            </p>

            <ul className="tw-mt-6 tw-mb-0 tw-list-none tw-space-y-3 tw-border-t tw-border-[#cedeeb] tw-p-0 tw-pt-6">
              {way.includes.map((item) => (
                <li key={item} className="tw-flex tw-gap-3 tw-text-sm tw-font-bold tw-text-[#314b64]">
                  <CheckIcon aria-hidden className="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-text-[#16a784]" />
                  {item}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </Section>
  );
}
